import { Component } from '@angular/core';

@Component({
  selector: 'qb-ita-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {}
